import Sales from '../../../../services/sales'

export default {
  props: ['rescueData'],
  data () {
    return {
      loading: undefined,
      feeValue: undefined,
      smallModal: false,
      totalValueVP: 0,
      totalFeeValue: 0,
      filter: {},
      transferMsg: new Array(),
    }
  },
  // computed: {
  //   contractIdCred() {
  //     const contract = this.$store.state.contract.contracts.find(contract => contract.plan.planId == 6 || contract.plan.planId == 8);
  //     return contract.contractId;
  //   }
  // },
  mounted() {
    let vm = this;

    if (this.rescueData.length > 0) {
      this.smallModal = true;
      this.rescueData.forEach(o => {
        vm.totalValueVP += o.transferValue;
        vm.totalFeeValue += o.feeValue;
      });
      // this.feeValue = this.totalValueVP * this.rescueData.feeTax;
      this.feeValue = this.totalFeeValue;
      this.filter = this.rescueData;
    } else {
      // this.feeValue = this.rescueData.feeValue;
      this.filter = [{
        index: 1,
        contractIdDeb : this.rescueData.contractIdVp,
        contractIdCred : this.rescueData.contractIdCred,
        transferValue : this.rescueData.transferValue,
        feeValue: this.rescueData.taxValue
      }];
    }
  },
  methods: {
    doRequest() {
      let vm = this;
      let filter = {transfer: this.filter};

      this.loading = Sales.transferCreditAggregate(filter).then(_ => {
        this.transferMsg = new Array();
          this.transferMsg.push('Transferência realizada com sucesso.');
      }).catch(_ => {
        this.transferMsg = new Array();
        this.transferMsg.push("Ocorreu um erro ao realizar a transferência.");
      });
    },
    closeModal() {
      let close = {
        modal: 'rescue-balance'
      };
      this.$emit('close', close);
      this.totalValueVP = undefined;
      this.feeValue = undefined;
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/modal-rescue-balance.js